export const supFixIncentiveBannerSupportedPaths = ['/women-fix', '/men-fix', '/gateway-fix', '/d/women-fix', '/d/men-fix', '/d/gateway-fix',
// New SUP Specific Pages
'/women/your-first-fix', '/men/your-first-fix'];